module.exports = __webpack_public_path__ + "img/2019091804-1.5ba62cf0.jpg";